import styled from "styled-components/macro";
import { device } from "../../device";

export const StyledNavbar = styled.nav`
  border-bottom: 1px solid #dfe3e8;
  background: #f4f6f8;
  position: sticky;
  top: 32px;
  z-index: 10;
  @media ${device.tablet}{
    top:0;
  }
`;
export const StyledList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  gap: 20px;
  padding: 20px;
  border-radius: 4px;

  @media ${device.tablet} {
    flex-wrap: wrap;
  }

  li > a {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #575e68;
    text-decoration: none;
    letter-spacing: 0em;
    background: #fcfcfd;
    border: 1px solid #babfc3;
    border-radius: 4px;
    padding: 10px 14px;
    margin: 10px 0;
    &:hover {
      cursor: pointer;
    }
  }

  @media ${device.mobileL} {
    justify-content: space-evenly;
    gap: 0.5rem;
    padding: 15px 5px;

    li > a {
      font-size: 10px;
      padding: 0.6rem 0.8rem;
      margin: 6px 0;
    }
  }
  @media ${device.mobileM} {
    gap: 0.1rem;
  }
`;
export const StyledTrialDaysCounter = styled.li`
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #575e68;
  min-width: 140px;
  @media ${device.mobileL} {
    font-size: 10px;
    margin-top: .5rem;
  }
`;
